const PriorityConditionChecker = (priority, t_) => {
  let errorMsg = ''
  if (priority < 1 || priority > 10) {
    errorMsg = t_('Priority must be between 1 and 10.')
  }
  return errorMsg
}
export default PriorityConditionChecker
